// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1MevN","bigColWidth":"Table_bigColWidth__3xRkN","biggerColWidth":"Table_biggerColWidth__2C9ZL","row":"Table_row__2vo00","col":"Table_col__3Ml-e"};